//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useContext, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";

// custom pages
import Table from "components/Table/Table";
import { UserConfirmationStyles } from "./styles";
import Context from "context/context";

// material-ui
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";

export default function UserConfirmation() {
  const { state, dispatch } = useContext(Context);
  const location = useLocation();
  const history = useHistory();
  const classes = UserConfirmationStyles();

  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "Enrollment / Transfer"],
    });
  }, []);

  let data = {};
  if (location.state?.data) {
    data = location.state?.data;
  } else {
    history.goBack();
  }
  return (
    <div>
      <Grid container style={{ padding: 10 }}>
        <Grid item xs={6}>
          <Button
            className={classes.backBtn}
            onClick={() => {
              history.push("/dashboard/create-users");
            }}
          >
            Back
          </Button>
        </Grid>
      </Grid>
      <Grid item xs={12} className={classes.contentGrid}>
        <div className={classes.content1}>Congratulations!</div>
        <div className={classes.content2}>
          Your Thrive Rewards loyalty account request has been successfully
          completed. Your loyalty account will be setup in {location?.state?.type === 1 ? "3-5" : "5-7"} business days.
          Once your account is setup completely you will be receiving an email
          and additional information on the program details.
        </div>
        <div className={classes.content3}>
          <div className={classes.content3Main}>
            <div className={classes.content3Div}>
              <span className={classes.content3Span}>Loyalty ID</span>:{" "}
              {data?.loyaltyId}
            </div>
          </div>
          <div className={classes.content3Main}>
            <div>
              <span className={classes.content3Span}>Billto ID</span>:{" "}
              {data?.billingId}
            </div>
          </div>
        </div>
        <div className={classes.content4}>
          {" "}
          Number of locations associated with this loyalty member.
        </div>
        <Table
          className={classes.table}
          headings={["Location", "Name", "City", "State"]}
          data={data?.customerAccounts?.map((d, i) => [
            d?.customer_account_number,
            d?.customer_name,
            d?.customer_address_city_name,
            d?.customer_address_state_code,
          ])}
          disablePagination={true}
        />
      </Grid>
    </div>
  );
}
